import {ICategoriaProducto} from '../interface/ICategoriaProducto';
import {Categoria} from './Categoria';
import {Producto} from './Producto';

export class CategoriaProducto implements ICategoriaProducto {

  categoriaId?: number;
  categoria?: Categoria;
  productoId: number;
  producto?: Producto;
  orden: number;
  fecCreacion?: Date;
  fecModificacion?: Date;

  nuevo?: boolean;
  antiguoOrden?: number;
  editado?: boolean;

  constructor(catProd: ICategoriaProducto) {
    this.categoriaId = catProd.categoriaId;
    this.categoria = catProd.categoria;
    this.productoId = catProd.productoId;
    if (catProd.producto) {
      this.producto = new Producto(catProd.producto);
    }
    this.orden = catProd.orden;
    this.antiguoOrden = catProd.orden;
    this.fecCreacion = catProd.fecCreacion;
    this.fecModificacion = catProd.fecModificacion;
    this.nuevo = catProd.nuevo;
    this.editado = catProd.editado;
  }


  getFormData(): FormData {
    const formData = new FormData();

    if (this.productoId) {
      formData.append('productoId', String(this.productoId));
    }
    if (this.orden) {
      formData.append('orden', String(this.orden));
    } else {
      formData.append('orden', '0');
    }
    return formData;
  }
}



// WEBPACK FOOTER //
// /app/src/model/class/CategoriaProducto.ts